/* eslint-disable @typescript-eslint/naming-convention */
import * as Yup from 'yup';

export const esquemaDeValidacionLogin = Yup.object().shape({
	nombreUsuarioCorreoDocumento: Yup.string().required('El correo o nombre de usuario es obligatorio'),
});

export const setValoresInicialesForm = () => ({
	nombreUsuarioCorreoDocumento: '',
});

export type ILogin = {
	nombreUsuarioCorreoDocumento: string;
};
